module.exports = __webpack_public_path__ + "static/media/no-photos.a07e9d82.png";